import { useCallback, useMemo } from "react";
import { Box, Typography, useTheme } from "@mui/material";

import { CollectionItemProps, CollectionItems } from "./collection-items";
import { useCollectionPageContext } from "./context";

export const LiveNow = () => {
  const theme = useTheme();

  const { items, isLoadingMore, hideShowMore, onShowMore } = useLiveNowItems();

  return (
    <CollectionItems
      title={
        <Box sx={{ height: 40 }}>
          <Box sx={{ display: "flex", alignItems: "center", columnGap: 1.5 }}>
            <Typography sx={{ fontFamily: "NFUltra-Regular", textTransform: "uppercase" }}>Live Now</Typography>

            <Box sx={{ width: 10, height: 10, bgcolor: theme.palette.error.main, borderRadius: "50%" }} />
          </Box>
        </Box>
      }
      itemBadge={
        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 12,
            bgcolor: theme.palette.error.main,
            borderRadius: 20,
            display: "flex",
            alignItems: "center",
            columnGap: 0.5,
            px: 0.6,
            py: 0.2,
          }}
        >
          <Box sx={{ width: 5, height: 5, bgcolor: "#fff", borderRadius: 5 }} />

          <Typography sx={{ color: "#fff", fontWeight: 500, fontSize: 10 }}>LIVE</Typography>
        </Box>
      }
      items={items}
      isLoadingMore={isLoadingMore}
      hideShowMore={hideShowMore}
      onShowMore={onShowMore}
    />
  );
};

const useLiveNowItems = () => {
  const { streamers, isLoadingStreamers, getCollectionStreamers } = useCollectionPageContext();

  const items: CollectionItemProps[] = streamers.data.map((item) => {
    return {
      thumbnail: item.stream_profile.thumbnail,
      avatar: item.photoUrl,
      title: item.fullName,
      description: item.username,
      slug: item.boltId,
    };
  });

  const hideShowMore = useMemo(() => {
    return streamers.data.length === streamers.total;
  }, [streamers.data.length, streamers.total]);

  const onShowMore = useCallback(() => {
    getCollectionStreamers({ page: streamers.page + 1, moreData: true });
  }, [getCollectionStreamers, streamers.page]);

  return { items, isLoadingMore: isLoadingStreamers, hideShowMore, onShowMore };
};
